import { css } from '@emotion/react';

export default $ => css`
  .clock {
    display: inline-flex;
    align-items: baseline;
    height: 1em;
    line-height: 1em;
    white-space: nowrap;

    > .time,
    > .date {
      font-size: inherit;
    }

    > .ampm {
      display: inline-block;
      padding-left: 0.25em;
      font-size: 0.75em;
      line-height: 1em;
      vertical-align: baseline;
    }
  }
`;
